// eslint-disable-next-line import/prefer-default-export
export const ROOT_CODE = 'home';
